const dashboard = {
  dashboard: {
    title: 'Tableau de bord',
    switchToClassic: 'Passer à la vue classique',
    comingSoon: 'Prochainement',
    companyScoreCard: 'Carte de pointage de performance de la société',
    enphaseSince: 'Installe de l’équipement Enphase depuis',
    sitesCommissioned: 'Sites mis en service',
    microinverters: 'Micro-onduleurs installés',
    batteriesInstalled: 'Batteries installées',
    nps: 'Taux de recommandation net',
    ensembleCertified: 'Société d’installation agréée de stockage',
    einLearn: 'En savoir plus sur EIN',
    yes: 'Oui',
    no: 'Non',
    lastMonth: {
      one: 'au cours du dernier mois',
      other: 'au cours des %{count} mois'
    },
    congratulations: 'Félicitations !',
    acceptInvitation: 'Accepter l’invitation',
    einInvitation: 'Vous avez reçu une invitation pour faire partie du Réseau d’installateur Enphase.',
    leadsInvitation: 'Vous avez reçu une invitation pour faire partie du Programme de prospects Enphase.',
    announcements: 'Annonces',
    systems: 'Systèmes',
    all: 'Tous',
    alerts: 'Alertes',
    activations: 'Activations',
    leads: 'Prospects',
    search: 'Recherche',
    noResult: 'Aucun résultat',
    viewActivations: 'Voir toutes les activations',
    viewLeads: 'Voir tous les prospects',
    viewSystems: 'Voir tous les systèmes',
    addNewSystems: 'Ajouter un nouveau système',
    total: 'Total',
    activatedSites: 'Sites activés',
    nameId: 'Nom / Identifiant',
    status: 'Statut',
    city: 'Ville',
    state: 'État / Province',
    //TODO - new translation added
    leadSource: 'Lead Source',
    createNewLead: 'Create New Lead',
    //TODO ends
    notAvailable: 'Non disponible',
    quickAccess: 'Accès rapide',
    contactUs: 'Nous contacter',
    ensemble: 'Ensemble',
    serviceShortcuts: 'Raccourcis de service',
    newsletter: 'Bulletin d’informations de l’installateur',
    service: 'Gestionnaire de service',
    enphaseleads: 'Programme de prospect Enphase',
    enphaseCommunity: 'Communauté Enphase',
    enphaseStore: 'Magasin Enphase',
    systemConfigurator: 'Configurateur de système',
    criticalUpdates: 'Mises à jour critiques',
    documentation: 'Documentation',
    brandLibrary: 'Bibliothèque de marque',
    training: 'Formation',
    newsBoard: 'Actualités',
    noContentAvailable: 'Aucun contenu disponible',
    viewEinDashboard: 'Voir le tableau de bord EIN',
    enterComments: 'Saisissez vos commentaires',
    maxAllowedComment: 'Un maximum de %{maxCount} caractères est autorisé',
    switchingBackNote:
      'Revenir à la version classique d’Enlighten Manager ? Aidez-nous à améliorer la nouvelle version en partageant votre raison de revenir à l’ancienne version',
    switchBackTitle: 'Passer à la vue classique pour une durée limitée',
    new: 'Nouveau',
    view: 'Voir',
    gridProfileToken: 'Jeton de changement du profil réseau',
    ProfileTokenText: 'Jeton de changement du profil',
    validText: 'Ce jetons et valide pour l’Envoy %{serialNumber} pendant un jour.',
    envoySerialNumber: 'Numéro de série de l’Envoy',
    authorizationNumber: `Numéro d’autorisation`,
    getToken: 'Obtenir un jeton',
    viewAll: 'Tout voir',
    viewFullList: 'Voir la liste complète',
    serviceRequests: 'Demandes de services',
    inProgressRequests: 'En cours',
    totalCases: 'Total de cas',
    resolvedRequests: 'Résolu',
    viewDetails: 'Voir les détails'
  }
};

export default dashboard;
